import React from 'react';

const ResultBar = ({ score = 0, label, sublabel, ctaLabel, onCta, tone }) => {
  const inferredTone = tone || (score > 60 ? 'green' : 'pink');
  const inferredLabel = label || (score > 80 ? 'BULLSEYE!' : score > 50 ? 'NICE READ' : 'OFF THE MARK');

  return (
    <div style={{
      display: 'flex', gap: 10, alignItems: 'center', width: '100%',
      background: `var(--c-${inferredTone})`,
      color: 'var(--c-cream)',
      border: 'var(--border-ink)',
      borderRadius: 14,
      padding: '10px 14px',
      boxShadow: 'var(--shadow-hard)',
    }}>
      <div style={{
        fontFamily: 'var(--font-display)', fontSize: 26, lineHeight: 1,
        background: 'var(--c-ink)', padding: '8px 10px', borderRadius: 10,
        flexShrink: 0,
      }}>+{score}</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: 14, letterSpacing: 0.4 }}>{inferredLabel}</div>
        {sublabel && (
          <div style={{
            fontFamily: 'var(--font-mono)', fontSize: 10, opacity: 0.9,
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }}>{sublabel}</div>
        )}
      </div>
      {ctaLabel && onCta && (
        <button onClick={onCta} style={{
          fontFamily: 'var(--font-display)', fontSize: 13, letterSpacing: 0.4,
          padding: '8px 12px', border: '2px solid var(--c-ink)', borderRadius: 10,
          background: 'var(--c-cream)', color: 'var(--c-ink)', cursor: 'pointer',
          boxShadow: 'var(--shadow-hard-sm)',
          flexShrink: 0,
        }}>{ctaLabel}</button>
      )}
    </div>
  );
};

export default ResultBar;
